import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  { path: "/404", component: () => import("@/views/404"), hidden: true },
  {
    path: "",
    component: Layout,
    redirect: "/home",
    // meta: {title: '首页', icon: 'home'},
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index"),
        meta: { title: "首页", icon: "home" }
        // meta: {title: '仪表盘', icon: 'dashboard'}
      }
      // ,
      // {
      //   name: 'document',
      //   path: 'https://www.macrozheng.com',
      //   meta: {title: '学习教程', icon: 'document'}
      // },
      // {
      //   name: 'video',
      //   path: 'https://www.macrozheng.com/mall/catalog/mall_video.html',
      //   meta: {title: '视频教程', icon: 'video'}
      // },
    ]
  }
];

export const asyncRouterMap = [
  {
    path: "/pms",
    component: Layout,
    redirect: "/pms/product",
    name: "pms",
    meta: { title: "产品", icon: "product" },
    children: [
      {
        path: "product",
        name: "product",
        component: () => import("@/views/pms/product/index"),
        meta: { title: "产品列表", icon: "product-list" }
      },
      {
        path: "productCate",
        name: "productCate",
        component: () => import("@/views/pms/cate/index"),
        meta: { title: "产品分类", icon: "product-cate" }
      },
      // {
      //   path: "productAttr",
      //   name: "productAttr",
      //   component: () => import("@/views/pms/productAttr/index"),
      //   meta: { title: "产品类型", icon: "product-attr" }
      // },
      {
        path: "addProduct",
        name: "addProduct",
        component: () => import("@/views/pms/product/add"),
        meta: { title: "添加产品", icon: "product-add" },
        hidden: true,
      },
      {
        path: "updateProduct",
        name: "updateProduct",
        component: () => import("@/views/pms/product/update"),
        meta: { title: "修改产品", icon: "product-add" },
        hidden: true
      },
      {
        path: "addProductCate",
        name: "addProductCate",
        component: () => import("@/views/pms/productCate/add"),
        meta: { title: "添加产品分类" },
        hidden: true
      },
      {
        path: "updateProductCate",
        name: "updateProductCate",
        component: () => import("@/views/pms/productCate/update"),
        meta: { title: "修改产品分类" },
        hidden: true
      },
      {
        path: "productAttrList",
        name: "productAttrList",
        component: () => import("@/views/pms/productAttr/productAttrList"),
        meta: { title: "产品属性列表" },
        hidden: true
      },
      {
        path: "addProductAttr",
        name: "addProductAttr",
        component: () => import("@/views/pms/productAttr/addProductAttr"),
        meta: { title: "添加产品属性" },
        hidden: true
      },
      {
        path: "updateProductAttr",
        name: "updateProductAttr",
        component: () => import("@/views/pms/productAttr/updateProductAttr"),
        meta: { title: "修改产品属性" },
        hidden: true
      },
      {
        path: "brand",
        name: "brand",
        component: () => import("@/views/pms/brand/index"),
        meta: { title: "品牌管理", icon: "product-brand" }
      },
      {
        path: "addBrand",
        name: "addBrand",
        component: () => import("@/views/pms/brand/add"),
        meta: { title: "添加品牌" },
        hidden: true
      },
      {
        path: "updateBrand",
        name: "updateBrand",
        component: () => import("@/views/pms/brand/update"),
        meta: { title: "编辑品牌" },
        hidden: true
      },
      {
        path: "attributeGroup",
        name: "attributeGroup",
        component: () => import("@/views/pms/attributeGroup/index"),
        meta: { title: "属性组", icon: "product-cate" }
      },
      {
        path: "attributelist",
        name: "attributelist",
        component: () => import("@/views/pms/attributeGroup/attributelist/index"),
        meta: { title: "属性列表", icon: "product-cate" },
        hidden: true
      },
    ]
  },
  {
    path: "/oms",
    component: Layout,
    redirect: "/oms/order",
    name: "oms",
    meta: { title: "订单", icon: "order" },
    children: [
      {
        path: "order",
        name: "order",
        component: () => import("@/views/oms/order/index"),
        meta: { title: "订单列表", icon: "product-list" }
      },
      {
        path: "orderDetail",
        name: "orderDetail",
        component: () => import("@/views/oms/order/orderDetail"),
        meta: { title: "订单详情" },
        hidden: true
      },
      {
        path: "orderProduct",
        name: "orderProduct",
        component: () => import("@/views/oms/product/index"),
        meta: { title: "订单产品", icon: "product-list" }
        // hidden:true
      },
      {
        path: "deliverOrderList",
        name: "deliverOrderList",
        component: () => import("@/views/oms/order/deliverOrderList"),
        meta: { title: "发货列表" },
        hidden: true
      },
      {
        path: "orderSetting",
        name: "orderSetting",
        component: () => import("@/views/oms/order/setting"),
        meta: { title: "订单设置", icon: "order-setting" }
      },
      {
        path: "returnApply",
        name: "returnApply",
        component: () => import("@/views/oms/apply/index"),
        meta: { title: "退货申请处理", icon: "order-return" }
      },
      {
        path: "returnReason",
        name: "returnReason",
        component: () => import("@/views/oms/apply/reason"),
        meta: { title: "退货原因设置", icon: "order-return-reason" }
      },
      {
        path: "returnApplyDetail",
        name: "returnApplyDetail",
        component: () => import("@/views/oms/apply/applyDetail"),
        meta: { title: "退货原因详情" },
        hidden: true
      }
    ]
  },
  {
    path: "/dms",
    component: Layout,
    redirect: "/dms/demand",
    name: "dms",
    meta: { title: "需求管理", icon: "order" },
    children: [
      {
        path: "demand",
        name: "demand",
        component: () => import("@/views/dms/demand/index"),
        meta: { title: "需求列表", icon: "tree" }
      }
    ]
  },
  {
    path: "/aiRepository",
    component: Layout,
    redirect: "/aiRepository/document",
    name: "aiRepository",
    meta: { title: "文件管理", icon: "order" },
    children: [
      {
        path: "document",
        name: "document",
        component: () => import("@/views/aiRepository/document/index"),
        meta: { title: "文件管理", icon: "tree" }
      }
    ]
  },
  // {
  //   path:'/sms',
  //   component: Layout,
  //   redirect: '/sms/coupon',
  //   name: 'sms',
  //   meta: {title: '营销', icon: 'sms'},
  //   children: [
  //     {
  //       path: 'flash',
  //       name: 'flash',
  //       component: () => import('@/views/sms/flash/index'),
  //       meta: {title: '秒杀活动列表', icon: 'sms-flash'}
  //     },
  //     {
  //       path: 'flashSession',
  //       name: 'flashSession',
  //       component: () => import('@/views/sms/flash/sessionList'),
  //       meta: {title: '秒杀时间段列表'},
  //       hidden:true
  //     },
  //     {
  //       path: 'selectSession',
  //       name: 'selectSession',
  //       component: () => import('@/views/sms/flash/selectSessionList'),
  //       meta: {title: '秒杀时间段选择'},
  //       hidden:true
  //     },
  //     {
  //       path: 'flashProductRelation',
  //       name: 'flashProductRelation',
  //       component: () => import('@/views/sms/flash/productRelationList'),
  //       meta: {title: '秒杀产品列表'},
  //       hidden:true
  //     },
  //     {
  //       path: 'coupon',
  //       name: 'coupon',
  //       component: () => import('@/views/sms/coupon/index'),
  //       meta: {title: '优惠券列表', icon: 'sms-coupon'}
  //     },
  //     {
  //       path: 'addCoupon',
  //       name: 'addCoupon',
  //       component: () => import('@/views/sms/coupon/add'),
  //       meta: {title: '添加优惠券'},
  //       hidden:true
  //     },
  //     {
  //       path: 'updateCoupon',
  //       name: 'updateCoupon',
  //       component: () => import('@/views/sms/coupon/update'),
  //       meta: {title: '修改优惠券'},
  //       hidden:true
  //     },
  //     {
  //       path: 'couponHistory',
  //       name: 'couponHistory',
  //       component: () => import('@/views/sms/coupon/history'),
  //       meta: {title: '优惠券领取详情'},
  //       hidden:true
  //     },
  //     {
  //       path: 'brand',
  //       name: 'homeBrand',
  //       component: () => import('@/views/sms/brand/index'),
  //       meta: {title: '品牌推荐', icon: 'product-brand'}
  //     },
  //     {
  //       path: 'new',
  //       name: 'homeNew',
  //       component: () => import('@/views/sms/new/index'),
  //       meta: {title: '新品推荐', icon: 'sms-new'}
  //     },
  //     {
  //       path: 'hot',
  //       name: 'homeHot',
  //       component: () => import('@/views/sms/hot/index'),
  //       meta: {title: '人气推荐', icon: 'sms-hot'}
  //     },
  //     {
  //       path: 'subject',
  //       name: 'homeSubject',
  //       component: () => import('@/views/sms/subject/index'),
  //       meta: {title: '专题推荐', icon: 'sms-subject'}
  //     },
  //     {
  //       path: 'advertise',
  //       name: 'homeAdvertise',
  //       component: () => import('@/views/sms/advertise/index'),
  //       meta: {title: '广告列表', icon: 'sms-ad'}
  //     },
  //     {
  //       path: 'addAdvertise',
  //       name: 'addHomeAdvertise',
  //       component: () => import('@/views/sms/advertise/add'),
  //       meta: {title: '添加广告'},
  //       hidden:true
  //     },
  //     {
  //       path: 'updateAdvertise',
  //       name: 'updateHomeAdvertise',
  //       component: () => import('@/views/sms/advertise/update'),
  //       meta: {title: '编辑广告'},
  //       hidden:true
  //     }
  //   ]
  // },
  {
    path: "/ums",
    component: Layout,
    redirect: "/ums/admin",
    name: "ums",
    meta: { title: "权限", icon: "ums" },
    children: [
      {
        path: "admin",
        name: "admin",
        component: () => import("@/views/ums/admin/index"),
        meta: { title: "员工管理", icon: "ums-admin" }
      },
      {
        path: "role",
        name: "role",
        component: () => import("@/views/ums/role/index"),
        meta: { title: "角色管理", icon: "ums-role" }
      },
      {
        path: "menu",
        name: "menu",
        component: () => import("@/views/ums/menu/index"),
        meta: { title: "菜单管理", icon: "ums-menu" }
      },
      {
        path: "news",
        name: "news",
        component: () => import("@/views/ums/news/index"),
        meta: { title: "资讯管理", icon: "product-list" }
      },
      {
        path: "config",
        name: "config",
        component: () => import("@/views/ums/config/index"),
        meta: { title: "配置管理", icon: "ums-menu" }
      },
      {
        path: "SysJob",
        name: "SysJob",
        component: () => import("@/views/job/index"),
        meta: { title: "定时任务", icon: "ums-menu" }
      }
    ]
  },{
    path: "/hiring",
    component: Layout,
    redirect: "/hiring/education",
    name: "hiring",
    meta: { title: "招聘", icon: "table" },
    children: [
      {
        path: "positionResume",
        name: "positionResume",
        component: () => import("@/views/hiring/positionResume/index"),
        meta: { title: "学历信息", icon: "product" }
      },
      {
        path: "education",
        name: "education",
        component: () => import("@/views/hiring/education/index"),
        meta: { title: "学历信息", icon: "product-list" }
      },
      {
        path: "position",
        name: "position",
        component: () => import("@/views/hiring/position/index"),
        meta: { title: "职位信息", icon: "product-cate" }
      },
      {
        path: "resume",
        name: "resume",
        component: () => import("@/views/hiring/resume/index"),
        meta: { title: "职位信息", icon: "tree" }
      },
      {
        path: "type",
        name: "type",
        component: () => import("@/views/hiring/type/index"),
        meta: { title: "招聘类型", icon: "sms" }
      }
    ]
  },
  {
    path: "/chat",
    component: Layout,
    redirect: "/chat/question",
    name: "chat",
    meta: { title: "群聊", icon: "ums" },
    children: [
      {
        path: "questionList",
        name: "questionList",
        component: () => import("@/views/chat/question/index"),
        meta: { title: "问题列表", icon: "ums-admin" }
      },
      {
        path: "chatList",
        name: "chatList",
        component: () => import("@/views/chat/group/index"),
        meta: { title: "群聊列表", icon: "ums-role" }
      },
      {
        path: "chatStat",
        name: "chatStat",
        component: () => import("@/views/chat/stat/index"),
        meta: { title: "群聊统计", icon: "ums-menu" }
      },
      {
        path: "loginStat",
        name: "loginStat",
        component: () => import("@/views/chat/stat/login/index"),
        meta: { title: "登录统计", icon: "ums-menu" }
      },
      // {
      //   path: "menu",
      //   name: "menu",
      //   component: () => import("@/views/ums/menu/index"),
      //   meta: { title: "菜单列表", icon: "ums-menu" }
      // }
    ]
  },
  {
    path: "/cons",
    component: Layout,
    redirect: "/cons/consumer",
    name: "cons",
    meta: { title: "用户列表", icon: "ums" },
    children: [
      {
        path: "consumer",
        name: "consumer",
        component: () => import("@/views/cons/consumer/index"),
        meta: { title: "用户管理", icon: "ums-admin" }
      },
      {
        path: "company",
        name: "company",
        component: () => import("@/views/cons/company/index"),
        meta: { title: "公司管理", icon: "ums-admin" }
      }
    ]
  },
  { path: "*", redirect: "/404", hidden: true }
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js